"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _default = {
  UPDATE_MATCH: '@@found/UPDATE_MATCH',
  RESOLVE_MATCH: '@@found/RESOLVE_MATCH'
};
exports["default"] = _default;
module.exports = exports.default;